/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import moment from "moment";
import { SOUND, Image_3D } from "../../assets/images";

export const DETAIL_DATA = [
    {
        idx: "1",
        title: "Johnnie Walker Blue Label Blended Scotch Whisky",
        subtitle: [
            "Johnnie Walker Blue Label Blended Scotch Whisky",
        ],
        serialNo: "Rare #/1",
        img: "https://i.ibb.co/Hqj3kJn/1-Blue-Label-Legendary.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.323,
            },
        ],
        createdBy: {
            userName: "DiageoIndia",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmQBW9DNxkgygNCASmqCqmTD5CahY378si3a3NZFEDQtkX",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/Hqj3kJn/1-Blue-Label-Legendary.png",
                thumbnail:
                    "https://i.ibb.co/Hqj3kJn/1-Blue-Label-Legendary.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
            {
                original:
                    "https://i.ibb.co/3722yX4/1-1-Blue-Label-Legendary.jpg",
                thumbnail:
                    "https://i.ibb.co/3722yX4/1-1-Blue-Label-Legendary.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 1200,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.25,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "2",
        title: "Antiquity Blue Ultra Premium Whisky",
        subtitle: [
            "Antiquity Blue Ultra Premium Whisky",
        ],
        serialNo: "Rare #/2",
        img: "https://i.ibb.co/F0J90gQ/2-ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmZPacuYFCucDQatXANQbznFH1FmuYvu87zTgvcRDtHDjh",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/F0J90gQ/2-ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.jpg",
                thumbnail:
                    "https://i.ibb.co/F0J90gQ/2-ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.jpg:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "3",
        title: "Ciroc Vodka",
        subtitle: [
            "Ciroc Vodka",
        ],
        serialNo: "Rare #/3",
        img: "https://i.ibb.co/yyckSnZ/6-ciroc.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
               "https://assetgateway.vantr.io/ipfs/QmaCJgSLomTDpFfrqpQTmJhiJBJQgQYfiSc8eYC7CApByg",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/yyckSnZ/6-ciroc.jpg",
                thumbnail:
                    "https://i.ibb.co/yyckSnZ/6-ciroc.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "4",
        title: "Black & White Blended Scotch Whisky",
        subtitle: [
            "Black & White Blended Scotch Whisky",
        ],
        serialNo: "Rare #/4",
        img: "https://i.ibb.co/6vDqfgn/10-Black-And-White.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmQgcsF2dHckdQC5aMn4wvTszJyYuHBvGKpXk85S5pYxAM",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/6vDqfgn/10-Black-And-White.jpg",
                thumbnail:
                    "https://i.ibb.co/6vDqfgn/10-Black-And-White.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "5",
        title: "Signature Rare Aged Whisky",
        subtitle: [
            "Signature Rare Aged Whisky",
        ],
        serialNo: "Rare #/5",
        img: "https://i.ibb.co/xY1MJCn/7-SIGNATURE-RARE-AGED-WHISKY.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmTMMWhzzzXKgYQM9xde1XPgqTUX439jUUfQTEupAERhgX",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/xY1MJCn/7-SIGNATURE-RARE-AGED-WHISKY.jpg",
                thumbnail:
                    "https://i.ibb.co/xY1MJCn/7-SIGNATURE-RARE-AGED-WHISKY.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "6",
        title: "Tanqueray London Dry Gin",
        subtitle: [
            "Tanqueray London Dry Gin",
        ],
        serialNo: "Rare #/6",
        img: "https://i.ibb.co/9qMK52Q/5-Tanqueray-Gin.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmcBqNQ9UXteJQBfnCBgWGDaoiT8Q5MwDj4gcj6Ktwhwfr",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/9qMK52Q/5-Tanqueray-Gin.png",
                thumbnail:
                    "https://i.ibb.co/9qMK52Q/5-Tanqueray-Gin.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "7",
        title: "McDowells No.1 Reserve Whisky",
        subtitle: [
            "McDowells No.1 Reserve Whisky",
        ],
        serialNo: "Rare #/7",
        img: "https://i.ibb.co/mT3Tm6T/8-MCDOWELLS-NO-1-RESERVE-WHISKY.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.3,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmPah2WFMRALkE7R4DfDenmfa2jcjgGanKSM6mAkUApxjC",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/mT3Tm6T/8-MCDOWELLS-NO-1-RESERVE-WHISKY.jpg",
                thumbnail:
                    "https://i.ibb.co/mT3Tm6T/8-MCDOWELLS-NO-1-RESERVE-WHISKY.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 90000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.3,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "8",
        title: "Black Dog Scotch Whisky",
        subtitle: [
            "Black Dog Scotch Whisky",
        ],
        serialNo: "Rare #/8",
        img: "https://i.ibb.co/7J7VDqt/9-Black-Dog.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2500,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.5,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmWL3Uf2vEoxsXhX53EQHiFnJjrECvPU42xUzBLPK7KU32",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/7J7VDqt/9-Black-Dog.jpg",
                thumbnail:
                    "https://i.ibb.co/7J7VDqt/9-Black-Dog.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 180000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.5,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "9",
        title: "Baileys Irish Whisky",
        subtitle: [
            "Baileys Irish Whisky",
        ],
        serialNo: "Rare #/9",
        img: "https://i.ibb.co/fCxXbVS/12-baileys-liqueur.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1400,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.39,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmZCptW1C3LD9NEscJobcAAowpRhePJKFH9uUobfpMkjMr",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/fCxXbVS/12-baileys-liqueur.jpg",
                thumbnail:
                    "https://i.ibb.co/fCxXbVS/12-baileys-liqueur.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 14000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.39,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "10",
        title: "Directors Special Whisky",
        subtitle: [
            "Directors Special Whisky",
        ],
        serialNo: "Rare #/10",
        img: "https://i.ibb.co/CK9wtDD/11-Directors-Special-Whisky.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1700,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.489,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmQrzdGBkKKUDrKF8kFRRXyXM92vcYThkYiHyftoEWhNTm",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/CK9wtDD/11-Directors-Special-Whisky.png",
                thumbnail:
                    "https://i.ibb.co/CK9wtDD/11-Directors-Special-Whisky.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 143000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.489 
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "11",
        title: "Smirnoff Vodka",
        subtitle: [
            "Smirnoff Vodka",
        ],
        serialNo: "Rare #/11",
        img: "https://i.ibb.co/HK8mWsk/3-Smirnoff.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.5,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmWrz3R5B9BVXX2LDXEp5ZDS5G7FPJGPEWjgdp48YFuEKu",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/HK8mWsk/3-Smirnoff.jpg",
                thumbnail:
                    "https://i.ibb.co/HK8mWsk/3-Smirnoff.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 128000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.5,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },  
    {
        idx: "12",
        title: "Vat 69 is a blended Scotch whisky",
        subtitle: [
            "Vat 69 is a blended Scotch whisky",
        ],
        serialNo: "Rare #/12",
        img: "https://i.ibb.co/N9C22sP/4-vat-69-black.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmcEVbeMx5VQRvB1B1b5iW9BMxyH7m1DM1XewtPQveopqA",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/N9C22sP/4-vat-69-black.png",
                thumbnail:
                    "https://i.ibb.co/N9C22sP/4-vat-69-black.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "21",
        title: "Taste the Sprit of Challengers",
        subtitle: [
            "Taste the Sprit of Challengers",
        ],
        serialNo: "Rare #/21",
        img: "https://i.ibb.co/kym0N1Y/RCB-Players.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/Qmb64nCCyNLMt96axMD83gWQJfKcW324PkPDnJGyj31QoW",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/kym0N1Y/RCB-Players.png",
                thumbnail:
                    "https://i.ibb.co/kym0N1Y/RCB-Players.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "22",
        title: "Special edition RCB players jersey inspired IPL pack",
        subtitle: [
            "Special edition RCB players jersey inspired IPL pack",
        ],
        serialNo: "Rare #/22",
        img: "https://i.ibb.co/f9hy2BM/5-Bottles.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmZ9gmQP2CqFHKhEQuquJ2PU6QNSFCbN58Xo8P1o7BEc3H",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/f9hy2BM/5-Bottles.png",
                thumbnail:
                    "https://i.ibb.co/f9hy2BM/5-Bottles.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "23",
        title: "Saini Jersey No Inspired Bottle",
        subtitle: [
            "Saini Jersey No Inspired Bottle",
        ],
        serialNo: "Rare #/23",
        img: "https://i.ibb.co/GnvMTDW/bottle-96.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmVrsAUiCjd7K1bVGgzi9zNTVfB6nXiWFGjSNktDbtRBbr",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/GnvMTDW/bottle-96.jpg",
                thumbnail:
                    "https://i.ibb.co/GnvMTDW/bottle-96.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "24",
        title: "Chalal Jersey No Inspired Bottle",
        subtitle: [
            "Chalal Jersey No Inspired Bottle",
        ],
        serialNo: "Rare #/24",
        img: "https://i.ibb.co/PC65hk0/5-Bottles-3.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmXK9giwGFBfk8yiFQ3DaPw8Jq1Kt8Aurfd9bKL9QXUFKN",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/PC65hk0/5-Bottles-3.jpg",
                thumbnail:
                    "https://i.ibb.co/PC65hk0/5-Bottles-3.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "25",
        title: "AB Jersey No Inspired Bottle",
        subtitle: [
            "AB Jersey No Inspired Bottle",
        ],
        serialNo: "Rare #/25",
        img: "https://i.ibb.co/qxJ3rbK/5-Bottles-2.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmS9vf9nCbPyutZxwgDJpE6XiZ2VN6fnRkcHPBKWyb6Nqh",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/qxJ3rbK/5-Bottles-2.jpg",
                thumbnail:
                    "https://i.ibb.co/qxJ3rbK/5-Bottles-2.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo India",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "31",
        title: "No.1 YAARIJAM ORIGINALS",
        subtitle: [
            "No.1 YAARIJAM ORIGINALS",
        ],
        serialNo: "Rare #/31",
        img: "https://i.ibb.co/8dGYY9c/1-Yaari.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmXvJb8oyH49H58hR98ccggeX44DN2HE7NQdaTB76kaE82",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/8dGYY9c/1-Yaari.png",
                thumbnail:
                    "https://i.ibb.co/8dGYY9c/1-Yaari.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "32",
        title: "No.1 YAARIJAM FESTS",
        subtitle: [
            "No.1 YAARIJAM FESTS",
        ],
        serialNo: "Rare #/32",
        img: "https://i.ibb.co/h7kQp4Q/2-Yaari.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmTdeTf4CUESoB3QP9tZiWy4Jx8Q47BdLJ5WD7zsfEH2sL",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/h7kQp4Q/2-Yaari.png",
                thumbnail:
                    "https://i.ibb.co/h7kQp4Q/2-Yaari.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "33",
        title: "No.1 YAARIJAM PADS",
        subtitle: [
            "No.1 YAARIJAM PADS",
        ],
        serialNo: "Rare #/33",
        img: "https://i.ibb.co/8DJ65sB/3-Yaari.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmQguUDF8oGMoJXFqTVwfSBTPwodcu3jTruetZu5m3CmLu",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/8DJ65sB/3-Yaari.png",
                thumbnail:
                    "https://i.ibb.co/8DJ65sB/3-Yaari.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "34",
        title: "YAARIJAM",
        subtitle: [
            "YAARIJAM",
        ],
        serialNo: "Rare #/34",
        img: "https://i.ibb.co/8dmSXWD/4-Yaari.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmTCEVGBFrbcYY2hEvBXJCqychAGWWgip7ZUzrhbJAZrB3",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/8dmSXWD/4-Yaari.png",
                thumbnail:
                    "https://i.ibb.co/8dmSXWD/4-Yaari.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "41",
        title: "Johnnie-walker Grocery Shop Inventory",
        subtitle: [
            "Johnnie-walker Grocery Shop Inventory",
        ],
        serialNo: "Rare #/41",
        img: "https://i.ibb.co/Bq0mDb9/jw-grocery-shop-inventory-1825-p1-dh-min.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmW72tCnUQP27crQt8zzxCYFJMCz8eQ3Z99d54SWYQgP16",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/Bq0mDb9/jw-grocery-shop-inventory-1825-p1-dh-min.jpg",
                thumbnail:
                    "https://i.ibb.co/Bq0mDb9/jw-grocery-shop-inventory-1825-p1-dh-min.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "42",
        title: "Johnnie-walker Balance Book",
        subtitle: [
            "Johnnie-walker Balance Book",
        ],
        serialNo: "Rare #/42",
        img: "https://i.ibb.co/KwYrHW8/Johnnie-Balance-book.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmTrBJQiEaoikN8tFjt7w7jSLsQkJLoSznuTuezb9rmtnk",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/KwYrHW8/Johnnie-Balance-book.jpg",
                thumbnail:
                    "https://i.ibb.co/KwYrHW8/Johnnie-Balance-book.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "43",
        title: "Johnnie-walker Sampling Room",
        subtitle: [
            "Johnnie-walker Sampling Room",
        ],
        serialNo: "Rare #/43",
        img: "https://i.ibb.co/LJHW9S3/Sampling-Room.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmSCQ2j2QsY8MVYPsM1mP6FKysMa3YYR6zLj43wUg7biA7",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/LJHW9S3/Sampling-Room.jpg",
                thumbnail:
                    "https://i.ibb.co/LJHW9S3/Sampling-Room.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "44",
        title: "Walking with Johnnie-walker",
        subtitle: [
            "Walking with Johnnie-walker",
        ],
        serialNo: "Rare #/44",
        img: "https://i.ibb.co/DpMJ80z/Johnnie.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmU2DRyWyGwbRkb4dWC7zLttBrZuvR4NX1y5x2HccFZDcn",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/DpMJ80z/Johnnie.jpg",
                thumbnail:
                    "https://i.ibb.co/DpMJ80z/Johnnie.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "45",
        title: "Walk with John walker",
        subtitle: [
            "Walk with John walker",
        ],
        serialNo: "Rare #/45",
        img: "https://i.ibb.co/hLt6wd9/Johnnie-walker.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmfWTAjMrpatqubRmnMHYVgdFhNQhFpZNzrWNHy5k3CmjN",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/hLt6wd9/Johnnie-walker.png",
                thumbnail:
                    "https://i.ibb.co/hLt6wd9/Johnnie-walker.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "46",
        title: "Go Green.Time for Change",
        subtitle: [
            "Go Green.Time for Change",
        ],
        serialNo: "Rare #/46",
        img: "https://i.ibb.co/jTLPvZg/Johnnie-Plastic-paper.jpg",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmfWTAjMrpatqubRmnMHYVgdFhNQhFpZNzrWNHy5k3CmjN",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/jTLPvZg/Johnnie-Plastic-paper.jpg",
                thumbnail:
                    "https://i.ibb.co/jTLPvZg/Johnnie-Plastic-paper.jpg/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "51",
        title: "Craft-whisky-with-united-s-epitome-reserve.  No:555",
        subtitle: [
            "Craft-whisky-with-united-s-epitome-reserve.  No:555",
        ],
        serialNo: "Rare #/51",
        img: "https://i.ibb.co/wSyCnnK/epitome-1.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmTuVEovKDcTg5UixzZL7jVLjyD5w8bybJSUGRGpk7CzsL",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/wSyCnnK/epitome-1.png",
                thumbnail:
                    "https://i.ibb.co/wSyCnnK/epitome-1.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "52",
        title: "Craft-whisky-with-united-s-epitome-reserve.  No:456",
        subtitle: [
            "Craft-whisky-with-united-s-epitome-reserve.  No:456",
        ],
        serialNo: "Rare #/51",
        img: "https://i.ibb.co/QdsfkY2/epitome-3.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/QmZ8BreD2MMEyzrGT4Sjro6aymLHdpnveyTw3qTszvFabF",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/QdsfkY2/epitome-3.png",
                thumbnail:
                    "https://i.ibb.co/QdsfkY2/epitome-3.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    {
        idx: "53",
        title: "Craft-whisky-with-united-s-epitome-reserve.  No:121",
        subtitle: [
            "Craft-whisky-with-united-s-epitome-reserve.  No:121",
        ],
        serialNo: "Rare #/53",
        img: "https://i.ibb.co/XZrhzG5/epitome-121.png",
        tag: "DIAMOND",
        productCategory: "collectibles",
        category: "diamond",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 2800,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.72,
            },
        ],
        createdBy: {
            userName: "Diageo India",
            userId: "DiageoIndia",
            link: "/DiageoIndia",
            authProofUrl:
                "https://assetgateway.vantr.io/ipfs/Qmaqd6xXMAVQ2XTKGyAW45kaCdWLeJPDGYKVsPJR9TikUe",
        },
        actions: [
            {
                key: "buyNowFiat",
                title: "Buy in USD",
            },
            {
                key: "buyNowCrypto",
                title: " Buy in ETH",
            },
        ],
        images: [
            {
                original:
                    "https://i.ibb.co/XZrhzG5/epitome-121.png",
                thumbnail:
                    "https://i.ibb.co/XZrhzG5/epitome-121.png/:/rs=h:70",
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            },
        ],
        nftProvenance: [
            {
                title: "Listed by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
                meta: {
                    price: [
                        {
                            type: "fiat",
                            currency: "INR",
                            locale: "en-IN",
                            amount: 29000,
                        },
                        {
                            type: "crypto",
                            currency: "ETH",
                            amount: 0.75,
                        },
                    ],
                },
            },
            {
                title: "Minted by",
                profile: {
                    userId: "DiageoIndia",
                    userName: "Diageo",
                    link: "/DiageoIndia",
                },
                eventOccurence: {
                    date: moment.utc(1634876074000).format("lll"),
                },
            },
        ],
        transactionButtons: [
            {
                key: "transactionDetail",
                title: "Transaction Details",
            },
            {
                key: "reSell",
                title: "Resell Item",
            },
        ],
        orderReciptButtons: [
            {
                key: "print",
                title: "Print",
            },
            {
                key: "download",
                title: "Download",
            },
        ],
        transactionDetail: {
            name: "Lorem Name",
            address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            contactInfo: "+91-5343453434",
            paymentInfo: "Lorem payment",
            paymentType: "Visas ending 2353",
            orderDate: "5 Nov 2018",
            price: "$4500",
            productTitle: "Casablanca",
            productDescription: [
                {
                    key: "Order Id",
                    value: "Ix43232",
                },
                {
                    key: "Created At",
                    value: "25 Oct 1997",
                },
                {
                    key: "Created By",
                    value: "Lorem Name",
                },
                {
                    key: "Purchased At",
                    value: "23 Aug 2020",
                },
                {
                    key: "Current Owner",
                    value: "Lorem Name",
                },
            ],
            productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
            orderStatus: 3,
            qrCodeLink: "https://www.google.com",
            orderTimeline: [
                {
                    title: "Product",
                    date: "23-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Transaction",
                    date: "24-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Validation",
                    date: "26-09-2018",
                    url: "https://www.google.com",
                },
                {
                    title: "Alloted",
                    date: "29-09-2018",
                    url: "https://www.google.com",
                },
            ],
            amountBreakup: [
                {
                    key: "Subtotal",
                    value: "$ 4500.00",
                },
                {
                    key: "Tax",
                    value: "$ 100.00",
                },
                {
                    key: "Gov Tax",
                    value: "$ 200.00",
                },
                {
                    key: "Total",
                    value: "$ 4800.00",
                },
            ],
        },
    },
    // {
    //     idx: "2",
    //     title: "Casablanca",
    //     subtitle: "During WWII, Rick, a nightclub owner in Casablanca, agrees to help his former lover Ilsa and her husband. Soon, Ilsa's feelings for Rick resurface and she finds herself renewing her love for him.",
    //     serialNo: 'Rare #/1801',
    //     img: "https://i.ibb.co/NKMBMBy/2.jpg",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     scAddress:"0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1",
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy:{
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Language', value: 'English' },
    //         { key: 'Date', value: '26 November 1942' },
    //         { key: 'Directed by', value: '	Michael Curtiz' },
    //         { key: 'Starring', value: '	Humphrey Bogart, Ingrid Bergman, Paul Henreid, Claude Rains, Conrad Veidt, Sydney GreenstreetPeter, Lorre' },
    //         { key: 'Production company', value: '	Warner Bros. Pictures' },
    //     ],
    //     action: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],

    //     images: [
    //         {
    //             original: 'https://i.ibb.co/F5Fty7S/5.png',
    //             thumbnail: 'https://i.ibb.co/F5Fty7S/5.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/wwz1rBJ/1.png',
    //             thumbnail: 'https://i.ibb.co/wwz1rBJ/1.png"',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/68KfTXc/casablanca-1.png',
    //             thumbnail: 'https://i.ibb.co/68KfTXc/casablanca-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "34",
    //     title: "STAR_WARS",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1101',
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Language', value: 'English' },
    //         { key: 'Writer', value: 'George Lucas' },
    //         { key: 'Directed by', value: 'George Lucas' },
    //         { key: 'Starring', value: 'Stars Mark HamillHarrison FordCarrie Fisher' },
    //         { key: 'Motion Picture Rating (MPAA)', value: ' Rated PG for sci-fi violence and brief mild language' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/kBM50wQ/star-wars-1.png',
    //             thumbnail: 'https://i.ibb.co/kBM50wQ/star-wars-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         }
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "15",
    //     title: "Krishnamachari Srikkanth",
    //     subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
    //     serialNo: 'Rare #/1250',
    //     img: "https://i.ibb.co/FVKL72x/ssrikanth-1.png",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.6900
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Date of Birth', value: 'December 21, 1959,' },
    //         { key: 'Batting Style', value: 'Right hand bat' },
    //         { key: 'Bowling Style', value: 'Right arm offbreak' },
    //         { key: 'Most catches in an innings', value: '5' },
    //         { key: 'Span', value: '1978/79 - 1992/93' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //             thumbnail: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "16",
    //     title: "K. Srikkanth Cover Drive",
    //     subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
    //     serialNo: 'Rare #/1251',
    //     img: "https://i.ibb.co/JmLxbXt/ssrikanth-2.png",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.55
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Date of Birth', value: 'December 21, 1959,' },
    //         { key: 'Batting Style', value: 'Right hand bat' },
    //         { key: 'Bowling Style', value: 'Right arm offbreak' },
    //         { key: 'Most catches in an innings', value: '5' },
    //         { key: 'Span', value: '1978/79 - 1992/93' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         // {
    //         //     original: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnail: 'https://i.ibb.co/FVKL72x/ssrikanth-1.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //         {
    //             original: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnail: 'https://i.ibb.co/JmLxbXt/ssrikanth-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         // {
    //         //     original: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnail: 'https://i.ibb.co/2hR06G2/ssrikanth-3.png',
    //         //     thumbnailHeight: "70",
    //         //     thumbnailClass:"image-thumb"
    //         // },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "3",
    //     title: "MS Dhoni",
    //     subtitle: "With a mature head on his shoulders and an astute and shrewd cricketing mind, Dhoni was recommended by senior players like Sachin Tendulkar and Rahul Dravid for captaincy after Rahul Dravid stepped down as skipper",
    //     serialNo: 'Rare #/1802',
    //     img: "https://i.ibb.co/smtvcrt/3.jpg",
    //     tag: 'PLATINUM',
    //     productCategory: 'collectibles',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5123
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Against', value: 'Sri Lanka' },
    //         { key: 'Date', value: '02 April 2011' },
    //         { key: 'Player of the match', value: 'MS Dhoni' },
    //         { key: 'Result', value: 'India won by 6 wickets (with 10 balls remaining)' },
    //         { key: 'Location', value: 'Wankhede Stadium Mumbai' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnail: 'https://i.ibb.co/WnL4Pt0/dhoni-5.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnail: 'https://i.ibb.co/YTh22Jn/dhoni-4.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnail: 'https://i.ibb.co/FK2XzmQ/dhoni-3.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "4",
    //     title: "AB De Villiers",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1201',
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 432.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Born', value: 'February 17, 1984, Pretoria' },
    //         { key: 'Batting', value: 'Right hand bat' },
    //         { key: 'Bowling', value: 'Right arm medium' },
    //         { key: 'Role', value: 'Wicketkeeper batter' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/cQ9Yx2t/ab-de-villiers.jpg',
    //             thumbnail: 'https://i.ibb.co/cQ9Yx2t/ab-de-villiers.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "31",
    //     title: "Joe Root",
    //     subtitle: "Joe Root, born on 30th December 1990, hails from a rich cricketing background. His grandfather captained Rotherham CC in the Yorkshire League for several seasons whilst his younger brother,",
    //     serialNo: 'Rare #/1202',
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 859.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Born', value: 'Dec 30, 1990 (30 years)' },
    //         { key: 'Batting', value: 'Right Handed Bat' },
    //         { key: 'Bowling', value: 'Right-arm offbreak' },
    //         { key: 'Role', value: 'Batter' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/hDpS47n/joe-root.jpg',
    //             thumbnail: 'https://i.ibb.co/hDpS47n/joe-root.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "32",
    //     title: "Ricky Ponting",
    //     subtitle: "Ricky Ponting had all the ingredients of a typical Australian - tough as nails, aggressive, vocal and above all, mentally powerful to tackle pressure situations. ",
    //     serialNo: 'Rare #/1203',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 52.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Born', value: 'Dec 19, 1974 (46 years)' },
    //         { key: 'Batting', value: 'Right Handed Bat' },
    //         { key: 'Bowling', value: 'Right-arm offbreak' },
    //         { key: 'Role', value: 'Batter' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/HpHjXBv/ricky-ponting.jpg',
    //             thumbnail: 'https://i.ibb.co/HpHjXBv/ricky-ponting.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "33",
    //     title: "David Warner",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1204',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 52.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.01
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Born', value: 'October 27, 1986, Paddington, New South Wales' },
    //         { key: 'Batting', value: 'Left hand bat' },
    //         { key: 'Bowling', value: 'Legbreak' },
    //         { key: 'Role', value: 'Opening batter' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/BG754kS/david-warner.jpg',
    //             thumbnail: 'https://i.ibb.co/BG754kS/david-warner.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "5",
    //     title: "1979 Worldcup Team",
    //     subtitle: "The 1979 Cricket World Cup was the second edition of the Cricket World Cup. Organised by the International Cricket Conference",
    //     serialNo: 'Rare #/1300',
    //     img: "https://i.ibb.co/PF00MG1/cricket-world-cup.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 3000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1.02
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Against', value: 'England' },
    //         { key: 'Date', value: 'Jun 23 1979' },
    //         { key: 'Player of the match', value: 'Viv Richards' },
    //         { key: 'Result', value: 'West Indies won by 92 runs' },
    //         { key: 'Location', value: 'Lord\'s, London' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/PF00MG1/cricket-world-cup.png',
    //             thumbnail: 'https://i.ibb.co/PF00MG1/cricket-world-cup.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/yg9pTBg/cricket-world-cup-2.png',
    //             thumbnail: 'https://i.ibb.co/yg9pTBg/cricket-world-cup-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "7",
    //     title: "Brian Lara\'s Era",
    //     subtitle: "A hero, a magician, an entertainer, a match-winner, a saviour, a leader, a tragic romantic, Brian Charles Lara, like a masterful actor, slipped in and out of several roles with effortless ease. First thing's first, Lara will forever be remembered as one of the greatest batsmen of the modern era, bracketed alongside the elite company of Sachin Tendulkar, Ricky Ponting and Jacques Kallis.",
    //     serialNo: 'Rare #/1302',
    //     img: "https://i.ibb.co/gmgjYxP/brian-lara-era.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     networkType: 'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 6000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.04
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Born', value: 'May 02, 1969 (52 years)' },
    //         { key: 'Birth Place', value: 'Cantaro, Santa Cruz, Trinidad' },
    //         { key: 'Height', value: '5 ft 8 in' },
    //         { key: 'Role', value: 'Batsman' },
    //         { key: 'Batting Style', value: 'Left Handed Bat' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnail: 'https://i.ibb.co/gmgjYxP/brian-lara-era.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "8",
    //     title: "QPCC Collections",
    //     subtitle: "The Queen’s Park Oval has been the Mecca of sport and Culture for decades, grounded in a rich history of the hosting of International Cricket, Football, Hockey, Athletics, Cycling, National Rallies, Cultural Showcases, Calypso/Soca Monarch and Beauty Queen Pageants.",
    //     serialNo: 'Rare #/1303',
    //     img: "https://i.ibb.co/kybfXnL/qpcc-collection.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     networkType: 'polygon',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 8000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.72
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Started Year', value: '1896' },
    //         { key: 'Place', value: 'Port of Spain, Trinidad and Tobago' },
    //         { key: 'Includes', value: 'Main cricket stadium' },
    //         { key: 'Includes', value: 'Members gym' },
    //         { key: 'Includes', value: 'indoor and outdoor cricket practice nets' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnail: 'https://i.ibb.co/kybfXnL/qpcc-collection.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "9",
    //     title: "Brian Lara\'s Test Hundreds",
    //     subtitle: "Brian Charles Lara, TC, OCC, AM is a Trinidadian former international cricketer, widely acknowledged as one of the greatest batsmen of all time.",
    //     serialNo: 'Rare #/1304',
    //     img: "https://i.ibb.co/R6kZyDC/lara-hundreds.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 9000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 3.10
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //         { key: 'Highest Score', value: '400*' },
    //         { key: 'Average', value: '53.17' },
    //         { key: 'Hundreds', value: '34' },
    //         { key: 'Fifties', value: '48' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnail: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnail: 'https://i.ibb.co/R6kZyDC/lara-hundreds.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "10",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1305',
    //     img: "https://i.ibb.co/FJ5KXYY/museum.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnail: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnail: 'https://i.ibb.co/FJ5KXYY/museum.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "11",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1306',
    //     img: "https://i.ibb.co/dJc6sjY/signature.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnail: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnail: 'https://i.ibb.co/dJc6sjY/signature.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "12",
    //     title: "QPCC",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1307',
    //     img: "https://i.ibb.co/cX2PD5d/sout-africa.png",
    //     tag: 'GOLD',
    //     productCategory: 'collectibles',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Span', value: '1990-2006' },
    //         { key: 'Matches', value: '130' },
    //         { key: 'Innings', value: '230' },
    //         { key: 'Not out', value: '6' },
    //         { key: 'Runs', value: '11912' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnail: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnail: 'https://i.ibb.co/cX2PD5d/sout-africa.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "6",
    //     title: "Virat Kohli\'s Lamborghini",
    //     subtitle: "A swanky Lamborghini used by Virat Kohli up for sale, and has run only 10000 km till date.",
    //     serialNo: 'Rare #/1301',
    //     img: "https://i.ibb.co/yYgM4JD/virat-lamb-1.png",
    //     tag: 'PLATINUM',
    //     productCategory: 'collectibles',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 182766.09
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 62.04
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'Model', value: '2015' },
    //         { key: 'Can reach', value: '0 to 100 km/h in just 4 seconds' },
    //         { key: 'KMs Driven', value: '10000' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/yYgM4JD/virat-lamb-1.png',
    //             thumbnail: 'https://i.ibb.co/yYgM4JD/virat-lamb-1.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/F6nvpRn/virat-lamb-2.png',
    //             thumbnail: 'https://i.ibb.co/F6nvpRn/virat-lamb-2.png',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "491",
    //     title: "Federal Reserve Note ",
    //     subtitle: "Very scarce replacement note.Minor tear in bottom margin and small ink spot near the portrait.",
    //     serialNo: 'Rare #/1800',
    //     img: "https://i.ibb.co/9THBcbT/1.jpg",
    //     tag: 'DIAMOND',
    //     productCategory: 'collectibles',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         {
    //             key: "Year",
    //             value: "1974"
    //         },
    //         {
    //             key: "Denomination",
    //             value: "$50"
    //         },
    //         {
    //             key: "Catalog",
    //             value: "J00295254"
    //         },
    //         {
    //             key: "Plate Position",
    //             value: "D"
    //         },
    //         {
    //             key: "Grade",
    //             value: "35"
    //         }
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             type: '3D',
    //             thumbnail: Image_3D,
    //             original: Image_3D,
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             src: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.glb?1542147958948",
    //             iosSrc: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b/Astronaut.usdz?v=1569545377878",
    //             poster: "https://cdn.glitch.com/36cb8393-65c6-408d-a538-055ada20431b%2Fposter-astronaut.png?v=1599079951717",
    //             shadowIntensity: "1",
    //             autoRotateAr: true,
    //             cameraControls: true
    //         }
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "492",
    //     title: "Federal Reserve Note ",
    //     subtitle: "Very scarce replacement note.Minor tear in bottom margin and small ink spot near the portrait.",
    //     serialNo: 'Rare #/1800',
    //     img: "https://i.ibb.co/9THBcbT/1.jpg",
    //     tag: 'DIAMOND',
    //     productCategory: 'collectibles',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         {
    //             key: "Year",
    //             value: "1974"
    //         },
    //         {
    //             key: "Denomination",
    //             value: "$50"
    //         },
    //         {
    //             key: "Catalog",
    //             value: "J00295254"
    //         },
    //         {
    //             key: "Plate Position",
    //             value: "D"
    //         },
    //         {
    //             key: "Grade",
    //             value: "35"
    //         }
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: " Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnail: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //             embedUrl: 'https://www.youtube.com/embed/D69igppLEjw?autoplay=1&showinfo=0'
    //         }
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],
    //     transactionButtons: [
    //         {
    //             key: "transactionDetail",
    //             title: "Transaction Details"
    //         },
    //         {
    //             key: "reSell",
    //             title: "Resell Item"
    //         }
    //     ],
    //     orderReciptButtons: [
    //         {
    //             key: "print",
    //             title: "Print"
    //         },
    //         {
    //             key: "download",
    //             title: "Download"
    //         },

    //     ],
    //     transactionDetail: {
    //         name: "Lorem Name",
    //         address: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //         contactInfo: "+91-5343453434",
    //         paymentInfo: "Lorem payment",
    //         paymentType: "Visas ending 2353",
    //         orderDate: "5 Nov 2018",
    //         price: "$4500",
    //         productTitle: "Casablanca",
    //         productDescription: [
    //             {
    //                 key: "Order Id",
    //                 value: "Ix43232"
    //             },
    //             {
    //                 key: "Created At",
    //                 value: "25 Oct 1997"
    //             },
    //             {
    //                 key: "Created By",
    //                 value: "Lorem Name"
    //             },
    //             {
    //                 key: "Purchased At",
    //                 value: "23 Aug 2020"
    //             },
    //             {
    //                 key: "Current Owner",
    //                 value: "Lorem Name"
    //             }
    //         ],
    //         productImg: "https://i.ibb.co/NKMBMBy/2.jpg",
    //         orderStatus: 3,
    //         qrCodeLink: "https://www.google.com",
    //         orderTimeline: [
    //             {
    //                 title: "Product",
    //                 date: "23-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Transaction",
    //                 date: "24-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Validation",
    //                 date: "26-09-2018",
    //                 url: "https://www.google.com"
    //             },
    //             {
    //                 title: "Alloted",
    //                 date: "29-09-2018",
    //                 url: "https://www.google.com"
    //             }
    //         ],
    //         amountBreakup: [
    //             {
    //                 key: "Subtotal",
    //                 value: "$ 4500.00"
    //             },
    //             {
    //                 key: "Tax",
    //                 value: "$ 100.00"
    //             },
    //             {
    //                 key: "Gov Tax",
    //                 value: "$ 200.00"
    //             },
    //             {
    //                 key: "Total",
    //                 value: "$ 4800.00",

    //             }
    //         ]
    //     },

    // },
    // {
    //     idx: "21",
    //     title: "Bermuda P23A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership."],
    //     serialNo: 'Rare #/23a',
    //     img: "https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     networkType: 'polygon',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'MATIC',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '561' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '1' },
    //         { key: 'Pick #', value: '23a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     actions: [
    //         {
    //             key: "claim",
    //             title: "CLAIM"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/qDVwmq2/Bermuda-P23a-F-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnail: 'https://i.ibb.co/G5t1Gnc/Bermuda-P23a-R-0212691.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "22",
    //     title: "Bermuda-P24A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/24a',
    //     img: "https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     networkType: 'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '562' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '5' },
    //         { key: 'Pick #', value: '24a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg',
    //             thumbnail: 'https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/gmx1B2k/Bermuda-P24a-R-0212692.jpg',
    //             thumbnail: 'https://i.ibb.co/gmx1B2k/Bermuda-P24a-R-0212692.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "23",
    //     title: "Bermuda P25A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/25a',
    //     img: "https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 4272.45
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '563' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '10' },
    //         { key: 'Pick #', value: '25a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg',
    //             thumbnail: 'https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/T8P641T/Bermuda-P25a-R-0212693.jpg',
    //             thumbnail: 'https://i.ibb.co/T8P641T/Bermuda-P25a-R-0212693.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "24",
    //     title: "Bermuda P26A Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/26a',
    //     img: "https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '564' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1970' },
    //         { key: 'Denomination', value: '20' },
    //         { key: 'Pick #', value: '26a' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 000070' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg',
    //             thumbnail: 'https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/f9NkmBG/Bermuda-P26a-R-0212694.jpg',
    //             thumbnail: 'https://i.ibb.co/f9NkmBG/Bermuda-P26a-R-0212694.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "25",
    //     title: "Bermuda P32B Note",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/32b',
    //     img: "https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 4272.45
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '1120' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1974' },
    //         { key: 'Denomination', value: '50' },
    //         { key: 'Pick #', value: '32b' },
    //         { key: 'Grade', value: 'VF' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 465860' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg',
    //             thumbnail: 'https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/cXD9R7S/Bermuda-P32b-R-0212695.jpg',
    //             thumbnail: 'https://i.ibb.co/cXD9R7S/Bermuda-P32b-R-0212695.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "26",
    //     title: "Bermuda P33C Note",
    //     subtitle: "Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.",
    //     serialNo: 'Rare #/33c',
    //     img: "https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '1547' },
    //         { key: 'Country', value: 'Bermuda' },
    //         { key: 'Year', value: '1986' },
    //         { key: 'Denomination', value: '100' },
    //         { key: 'Pick #', value: '33c' },
    //         { key: 'Grade', value: 'UNC' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 200021' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnail: 'https://i.ibb.co/xHQ2sVW/Bermuda-P33c-R-0212696.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "27",
    //     title: "British Caribbean Terr. P-6",
    //     subtitle: ["Actual banknote will be shipped along with instructions to claim NFT as Proof of Ownership.", ""],
    //     serialNo: 'Rare #/P6',
    //     img: "https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ],
    //     createdBy: {
    //         userName: "Diageo India",
    //         userId: 'DiageoIndia',
    //         link: "/DiageoIndia",
    //         authProofUrl: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP"
    //     },
    //     meta: [
    //         { key: 'SL. NO.', value: '009845' },
    //         { key: 'Country', value: 'British Caribbean Terr.' },
    //         { key: 'Year', value: '1950' },
    //         { key: 'Denomination', value: '100 Dollars' },
    //         { key: 'Sig', value: 'Robertson / McDavid  / Cuke' },
    //         { key: 'Pick #', value: 'P-6' },
    //         { key: 'Grade', value: 'Very Fine' },
    //         { key: 'Quantity', value: '1' },
    //         { key: 'S.No.', value: 'A1 009845' },
    //         { key: 'Printer', value: 'BWC' },
    //         { key: 'Theme', value: 'KGV1,map / 4 different arms' },
    //     ],
    //     actions: [
    //         {
    //             key: "buyNowFiat",
    //             title: "Buy in USD"
    //         },
    //         {
    //             key: "buyNowCrypto",
    //             title: "Buy in ETH"
    //         }
    //     ],
    //     info: [
    //         {
    //             url: '/provenance',
    //             title: 'Track and Field'
    //         }
    //     ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg',
    //             thumbnail: 'https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //         {
    //             original: 'https://i.ibb.co/JKRjLC0/Optimized-P6-Rear.jpg',
    //             thumbnail: 'https://i.ibb.co/JKRjLC0/Optimized-P6-Rear.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         },
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
    // {
    //     idx: "28",
    //     title: "Hemakuta",
    //     subtitle: ["According to Indian history, this is the hill that Lord Siva did penance before marrying a local girl Pampa. Siva was impressed by her dedication for him and consent to marry her. Due to this decision of Lord Shiva it rained gold on the hill. Since gold is known as Hema in Sanskrit, this hill came to be known as Hemakuta.", "Another legend has it that Hemakuta Hill was also the place where Lord Shiva had burnt Kama, the God of lust. Kama had helped Pampa to marry Shiva by distracting Shiva from his penance. This act of Kama angered Shiva and he killed Kama by emitting fire from his third eye. However, after Kama's wife Rathi pleaded with Shiva for the life of her husband, Shiva relented. Shiva brought back Kama to life but only in character and not as a physical being."],
    //     serialNo: 'Rare #/P28',
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     // price: [
    //     //     {
    //     //         type: 'fiat',
    //     //         currency: 'USD',
    //     //         locale: 'en-US',
    //     //         amount: 25000
    //     //     },
    //     //     {
    //     //         type: 'crypto',
    //     //         currency: 'ETH',
    //     //         amount: 5.29
    //     //     }
    //     // ],
    //     // buttons: [
    //     //     {
    //     //         key: "buyNowFiat",
    //     //         title: "Buy in USD"
    //     //     },
    //     //     {
    //     //         key: "buyNowCrypto",
    //     //         title: "Buy in ETH"
    //     //     }
    //     // ],
    //     images: [
    //         {
    //             original: 'https://i.ibb.co/2NPd5cR/hemakuta.jpg',
    //             thumbnail: 'https://i.ibb.co/2NPd5cR/hemakuta.jpg',
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb"
    //         }
    //     ],
    //     nftProvenance: [
    //         {
    //             title: "Listed by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //             meta: {
    //                 price: [
    //                     {
    //                         type: 'fiat',
    //                         currency: 'USD',
    //                         locale: 'en-US',
    //                         amount: 1500.00
    //                     },
    //                     {
    //                         type: 'crypto',
    //                         currency: 'ETH',
    //                         amount: 0.5
    //                     }
    //                 ],
    //             }
    //         },
    //         {
    //             title: "Minted by",
    //             profile: {
    //                 userId: 'DiageoIndia',
    //                 userName: 'Diageo India',
    //                 link: '/DiageoIndia'
    //             },
    //             eventOccurence: {
    //                 date: moment.utc(1634876074000).format('lll')
    //             },
    //         },
    //     ],

    // },
];

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "Stocks", value: "Stocks", disabled: true },
            { label: "Gold", value: "Gold" },
            { label: "NFT", value: "NFT" },
        ],
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "China", value: "china" },
            { label: "Pakistan", value: "pak", disabled: true },
            { label: "Russia", value: "rus" },
            { label: "Italy", value: "Italy" },
        ],
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Music", value: "Music" },
            { label: "Cricket", value: "Cricket" },
            { label: "Football", value: "Football" },
            { label: "Art", value: "Art" },
            { label: "Movies", value: "Movies" },
            { label: "Cars", value: "Cars" },
            { label: "Travel", value: "Travel" },
            { label: "Fashion", value: "Fashion", disabled: true },
            { label: "Food", value: "Food" },
            { label: "Country", value: "County" },
            { label: "Plants", value: "Plants" },
            { label: "Science", value: "Science" },
        ],
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ],
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "buyNowFiat", value: "buyNowFiat", disabled: true },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" },
        ],
    },
];

export const ownership = [
    {
        title: "View on IPFS",
        link: "https://gateway.pinata.cloud/ipfs/QmZ99AcbAiPK4RW2EPtWiXVzP3dgmKDVcFuQjGwJ6BKZuP",
    },
];

export const timeline = [
    {
        title: "Asset Listed",
        event: "listed",
        description: [
            {
                displayType: "price",
                key: "Price",
                value: 500,
                currency: "USD",
            },
            {
                displayType: "link",
                key: "From",
                value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
            {
                displayType: "link",
                key: "To",
                value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
            {
                displayType: "date",
                key: "Listed At",
                value: new Date().toISOString(),
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
        ],
    },
    {
        title: "Asset Minted",
        event: "minted",
        description: [
            {
                displayType: "price",
                key: "Price",
                value: 500,
                currency: "USD",
            },
            {
                displayType: "link",
                key: "From",
                value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
            {
                displayType: "link",
                key: "To",
                value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
            {
                displayType: "date",
                key: "Minted At",
                value: new Date().toISOString(),
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
        ],
    },
    {
        title: "Asset Created",
        event: "created",
        description: [
            {
                displayType: "price",
                key: "Price",
                value: 500,
                currency: "USD",
            },
            {
                displayType: "link",
                key: "From",
                value: "0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
            {
                displayType: "link",
                key: "To",
                value: "-",
            },
            {
                displayType: "date",
                key: "Created At",
                value: new Date().toISOString(),
                link: "https://rinkeby.etherscan.io/token/0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1?a=0xfd0cf4de0409885a8eebf51f88cf48bfea3ae83a",
            },
        ],
    },
];

 